module.exports = __webpack_public_path__ + "img/location_orange.bc84fd01.svg";